(() => {
  if (window.gcMemberCheckoutBound) return;
  window.gcMemberCheckoutBound = true;

  const ENDPOINT = 'https://backoffice.brightdigital.co/api/create-draft-order.php';
  const TIMEOUT_MS = 20000;
  const BUTTON = '.js-member-checkout';

  const setLoading = (button, isLoading) => {
    button.classList.toggle('loading', isLoading);
    button.setAttribute('aria-busy', String(isLoading));
  };

  const createDraftOrder = async (items) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
    try {
      const response = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
        signal: controller.signal
      });
      return await response.json();
    } finally {
      clearTimeout(timer);
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(BUTTON);
    if (!button || button.classList.contains('loading')) return;

    let items;
    try {
      items = JSON.parse(button.dataset.cartItems);
    } catch (e) {
      console.error('Member checkout: invalid cart data', e);
      alert('Something went wrong reading your cart. Please refresh and try again.');
      return;
    }

    setLoading(button, true);

    try {
      const result = await createDraftOrder(items);
      if (result.success && result.invoice_url) {
        // keep the spinner on while the browser navigates. Shopify sometimes needs a moment
        // to finish generating the invoice page after the draft order API call returns, so a
        // short delay here avoids landing on its "invoice not available yet" error.
        setTimeout(() => window.location.assign(result.invoice_url), 1000);
        return;
      }
      console.error('Member checkout failed', result);
      alert('Checkout could not be started. Please try again.');
    } catch (error) {
      console.error('Member checkout error', error);
      alert('Checkout could not be started. Please check your connection and try again.');
    }

    setLoading(button, false);
  });

  // Back button restores this page from the browser cache: the spinner would still be
  // spinning and prices could be stale (e.g. after logging out), so start from a fresh render.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) window.location.reload();
  });
})();
